// import axios from 'axios';
import axios from "../../services/axios";
import AuthenticationService from "../../services/authentication.service";
// const API_URL = process.env.VUE_APP_API_URL;
const getDefaultState = () => {
  return {
    originList: [],
    waitList: [],
  }
}

const state = getDefaultState()

const getters = {}

const actions = {
  CHECK_CASINO_WALLET(_, params) {
    return axios.post(`/casino/v2/check/wallet`, params).then(
      (response) => {
        return response;
      }
    );
  },
  GET_LOBBY(_, params) {
    return axios.post(`/casino/v2/lobby`, params).then(
      (response) => {
        return response;
      }
    );
  },
  GET_LIVE(_, params) {
    return axios.post(`/casino/cx/lobby/live`, params).then(
      (response) => {
        return response;
      }
    );
  },
  GET_SLOT(_, params) {
    return axios.post(`/casino/cx/lobby/slot`, params).then(
      (response) => {
        return response;
      }
    );
  },
  GET_GAME(_, params) {
    return axios.post(`/casino/cx/game`, params).then(
      (response) => {
        return response;
      }
    );
  },
  GET_KPLAY_SPORTS(_, params) {
    return AuthenticationService.casinoPost(`/kplay/ob/auth`, params).then(
      (response) => {
        return response;
      }
    );
  },
  GET_HONOR_GAME(_, params) {
    return axios.post(`/casino/honor/game`, params).then(
      (response) => {
        return response;
      }
    );
  },
  GET_HONOR_SLOT(_, params) {
    return axios.post(`/casino/honor/slot`, params).then(
      (response) => {
        return response;
      }
    );
  },
  OPEN_HONOR_GAME(_, params) {
    return axios.post(`casino/honor/open`, params).then(
      (response) => {
        return response;
      }
    );
  },
};

const mutations = {
  SET_INPLAY_LIST(state, payload) {
    state.originList = payload
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
